import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { LAUNCHED_COUNTRY } from "../../config/appConfigConstants";
import { RootState } from "../store";
import { CONFIG_DATA, CONFIG_FEATURE_FLAG } from "../../utility/enums/common";

type featureFlagItem = {
  [key in CONFIG_FEATURE_FLAG]: any;
};

type configDataItem = {
  [key in CONFIG_DATA]: any;
};

export interface ConfigState {
  featureFlag: {
    global: featureFlagItem;
    countries: { [key in LAUNCHED_COUNTRY]: featureFlagItem };
  };
  data: configDataItem;
}

export const initialState: ConfigState = {
  featureFlag: {
    global: {},
    countries: {
      US: {},
      GB: {},
      MX: {},
    },
  },
  data: {},
} as ConfigState;

export const configSlice = createSlice({
  name: "ConfigSlice",
  initialState,
  reducers: {
    setConfigData: (state, action: PayloadAction<{ key: CONFIG_DATA; value: any }>) => {
      const { key, value } = action.payload;
      state.data[key] = value;
    },
    setGlobalFeatureFlag: (state, action: PayloadAction<{ key: CONFIG_FEATURE_FLAG; value: any }>) => {
      const { key, value } = action.payload;
      state.featureFlag.global[key] = value;
    },
    setFeatureFlagByCountry: (
      state,
      action: PayloadAction<{ key: CONFIG_FEATURE_FLAG; value: any; country: LAUNCHED_COUNTRY }>
    ) => {
      const { key, value, country } = action.payload;
      state.featureFlag.countries[country][key] = value;
    },
  },
});

export const { setConfigData, setGlobalFeatureFlag, setFeatureFlagByCountry } = configSlice.actions;

export const getConfigData = (state: RootState) => state.config.data;
export const getGlobalFeatureFlag = (state: RootState) => state.config.featureFlag.global;
export const getUSFeatureFlag = (state: RootState) => state.config.featureFlag.countries.US;
export const getUKFeatureFlag = (state: RootState) => state.config.featureFlag.countries.GB;
export const getMXFeatureFlag = (state: RootState) => state.config.featureFlag.countries.MX;

export default configSlice.reducer;
